module.exports = __webpack_public_path__ + "static/media/coins.59d0e490.png";